import type { SVGProps } from "react";
export interface PlaneOffIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function PlaneOffIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: PlaneOffIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M10.134 1.875c1.085 0 2.092.563 2.66 1.487l3.085 5.013H18c1 0 2.195.394 3.127.931.475.275.942.621 1.305 1.033.353.402.694.97.694 1.661 0 .895-.564 1.588-1.06 2.027-.533.471-1.211.852-1.878 1.121a1.125 1.125 0 1 1-.84-2.087c.494-.199.932-.46 1.226-.72.204-.18.27-.297.292-.342a.8.8 0 0 0-.123-.173c-.153-.174-.405-.376-.741-.57-.607-.35-1.3-.57-1.8-.62L18 10.625h-2.749c-.39 0-.753-.203-.958-.535l-3.415-5.55a.88.88 0 0 0-.744-.416h-1.1a1.124 1.124 0 0 1-.804-2.093l.164-.068a1.6 1.6 0 0 1 .535-.089h1.205Zm-7.924.33a1.126 1.126 0 0 1 1.506-.078l.085.078 18 18 .077.085a1.125 1.125 0 0 1-1.583 1.583l-.085-.078-5.032-5.031-2.383 3.874a3.13 3.13 0 0 1-2.662 1.487H8.928a1.625 1.625 0 0 1-1.553-2.103l1.352-4.396H6.771L5.688 16.71a3.13 3.13 0 0 1-2.21.915H2.5a1.626 1.626 0 0 1-1.542-2.139L2.119 12 .958 8.514A1.626 1.626 0 0 1 2.5 6.375h.977l.31.015a3.13 3.13 0 0 1 1.9.9l1.084 1.085h.018L2.21 3.795l-.078-.084a1.126 1.126 0 0 1 .078-1.506m2.164 9.44c.077.23.077.48 0 .711l-1.008 3.02h.111l.171-.018a.88.88 0 0 0 .449-.24l1.413-1.413.172-.14c.183-.123.4-.19.624-.19h3.945a1.126 1.126 0 0 1 1.075 1.457l-1.552 5.043h.36a.88.88 0 0 0 .745-.416l2.663-4.332-4.503-4.502H6.306c-.299 0-.585-.119-.796-.33L4.097 8.881a.88.88 0 0 0-.62-.256h-.111z"
      />
    </svg>
  );
}
